export default function Footer() {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Auto Parts', href: '#parts' },
    { name: 'Services', href: '#services' },
    { name: 'Reviews', href: '#reviews' },
    { name: 'About Us', href: '#about' },
    { name: 'Location', href: '#location' }
  ];

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12 pb-12 border-b border-gray-700">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-1 h-12 bg-red-600"></div>
              <div>
                <div className="font-rajdhani font-bold text-xl leading-tight">N.A. DISCOUNT</div>
                <div className="font-rajdhani font-bold text-xl leading-tight">AUTO PARTS</div>
              </div>
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Quality auto parts at discount prices. Trusted for over 20 years in Mississauga and the GTA.
            </p>
            <div className="flex gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-fill text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-rajdhani font-bold text-xl mb-6">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-gray-400 hover:text-red-600 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-rajdhani font-bold text-xl mb-6">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-red-600 text-xl mt-1"></i>
                <address className="text-gray-400 not-italic">
                  3181 Wolfedale Rd, Unit 9<br />
                  Mississauga, Ontario
                </address>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-red-600 text-xl"></i>
                <a href="tel:905-226-0408" className="text-gray-400 hover:text-red-600 transition-colors cursor-pointer">
                  905-226-0408
                </a>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-time-line text-red-600 text-xl mt-1"></i>
                <div className="text-gray-400 text-sm">
                  Mon-Fri: 9:00 AM - 6:00 PM<br />
                  Sat: 9:00 AM - 5:00 PM<br />
                  Sun: Closed
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
          <p>&copy; {currentYear} N.A. Discount Auto Parts. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" className="hover:text-red-600 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="hover:text-red-600 transition-colors cursor-pointer">Terms of Service</a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-red-600 transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
